import { getChromeDeclarativeNetRequest } from '../../chrome/wrappers';

const youtubeUrlFilters = [
  '*://*.youtube.com/*',
  '*://www.youtube-nocookie.com/*',
  '*://youtube.googleapis.com/*',
  '*://youtubei.googleapis.com/*',
] as const;

const getAllResourceTypes = () =>
  Object.values(getChromeDeclarativeNetRequest().ResourceType);

const getAction = () => ({
  type: getChromeDeclarativeNetRequest().RuleActionType.MODIFY_HEADERS,
  requestHeaders: [
    {
      operation: getChromeDeclarativeNetRequest().HeaderOperation.SET,
      header: 'YouTube-Restrict',
      value: 'Strict',
    },
  ],
});

export const youtubeRules = () =>
  youtubeUrlFilters.map((urlFilter, index) => ({
    id: index + 1, // Each id needs to be unique and > 1
    priority: 1,
    action: getAction(),
    condition: {
      urlFilter,
      resourceTypes: getAllResourceTypes(),
    },
  }));
